import ProductCatalogGrid from "@/components/ProductCatalogGrid.jsx";
import { useProductRecommendations } from "@/hooks/useProductRecommendations.js";
import { useAuth } from "@/auth/AuthContext.jsx";
import { ROLES } from "@/utils/constants.js";
import "./product-recommendations.css";

const TITLE_ID = "product-recommendations-title";

export default function ProductRecommendations({
    excludeCart = false,
    excludeProductId = null,
    enabled = true,
    resetKey = "",
    className = ""
}) {
    const { isAuthenticated, role } = useAuth();
    // Customer-secure API only — hide for admins (and guests) instead of showing a failed request.
    const forCustomer = isAuthenticated && role === ROLES.CUSTOMER;
    const active = enabled && forCustomer;

    const {
        products,
        loading,
        loadingMore,
        error,
        sentinelRef,
        hasProducts
    } = useProductRecommendations({
        excludeCart,
        excludeProductId,
        enabled: active,
        resetKey
    });

    if (!active) {
        return null;
    }

    if (!loading && !hasProducts && !error) {
        return null;
    }

    return (
        <section
            className={`product-recommendations-panel ${className}`.trim()}
            aria-labelledby={TITLE_ID}
        >
            <header className="product-recommendations-panel__header">
                <h2 id={TITLE_ID} className="product-recommendations__title">
                    Nous vous recommandons
                </h2>
            </header>
            <div className="product-recommendations-panel__body">
                {loading && <p className="muted">Chargement des recommandations...</p>}
                {error && <p className="error">{error}</p>}
                {!loading && hasProducts && <ProductCatalogGrid products={products} />}
                {loadingMore && <p className="muted catalog-loading-more">Chargement de la suite...</p>}
                <div ref={sentinelRef} className="catalog-scroll-sentinel" aria-hidden="true" />
            </div>
        </section>
    );
}
